import { HeaderFooterLayout } from '../app';
import ContentfulPage from './ContentfulPage';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { TypePage } from '@platform/contentful';
import ErrorPage from '../../ErrorPage';
import { useRoute } from 'wouter';

export type ContentfulRootData = {
  sys: {
    type: 'Array';
  };
  total: number;
  skip: number;
  limit: number;
  items: TypePage<'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>[];
};

const ContentfulTarget = ({ contentfulData }: { contentfulData: ContentfulRootData | null }) => {
  const [_match, params] = useRoute('/*');

  let pageData =
    contentfulData && params ?
      contentfulData.items.find((item) => item.fields.slug === params['*'])
    : undefined;

  if (typeof window !== 'undefined' && 'CONTENTFUL_PAGE_DATA' in window) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pageData = (window as any)['CONTENTFUL_PAGE_DATA'] as TypePage<
      'WITHOUT_UNRESOLVABLE_LINKS',
      'en-US'
    >;
  }

  if (!pageData) {
    return <ErrorPage />;
  }

  return (
    <HeaderFooterLayout>
      <ContentfulLivePreviewProvider locale='en-US'>
        <ContentfulPage pageEntry={pageData} />
      </ContentfulLivePreviewProvider>
    </HeaderFooterLayout>
  );
};

export default ContentfulTarget;
